module.exports = __webpack_public_path__ + "fonts/Alibaba-PuHuiTi-Bold.38edfe18.ttf";